<div
  class="row col mb-1"
  style="
    display: flex;
    justify-content: flex-end;
    position: relative;
    right: 43px;
    top: 7px;
  "
>
  <button
    class="mr-3"
    (click)="close()"
    style="
      border: none;
      color: #714193;
      width: 0px;
      background-color: transparent;
      transform: scale(1.5);
    "
  >
    <i class="fa fa-close"></i>
  </button>
</div>
<body>
  <title>Termos e Condições - MONKEY MONEY</title>
  <h2 class="text-center mb-5">
    Termos e Condições Gerais de Uso – MONKEY MONEY
  </h2>

  <h3 style="color: black">1. INFORMAÇÕES GERAIS</h3>
  <p>
    1.1. Este documento possui a finalidade de informar a todos os interessados
    os Termos e Condições Gerais de Uso desta Plataforma de Marketplace
    oferecida pelo MONKEY MONEY.
  </p>
  <p>
    1.2. A empresa MONKEY MONEY é inscrita no CNPJ de nº 49.680.645/0001-01,
    possui sua sede localizada à Rua Milton Campos, nº 205, Sala nº 206, Bairro
    Cidade Nobre, Ipatinga/MG, CEP: 35162-393 e poderá ser referida neste Termo,
    dentre outras formas, como: "Plataforma", “Plataforma de Marketplace”,
    "empresa" ou simplesmente “MONKEY MONEY”
  </p>
  <p>
    1.3. Os Usuários e Visitantes, pessoas físicas ou jurídicas, são aqueles que
    utilizam da Plataforma Marketplace do MONKEY MONEY. Eles poderão ser
    referidos neste Termo, dentre outras formas, como: “Usuário”, “Usuários”,
    “Cliente”, “Clientes”, “Visitante”, “Visitantes”, “COMPRADOR”,
    “COMPRADORES”, “VENDEDOR” e/ou “VENDEDORES”.
  </p>
  <p>
    1.4. Ao utilizar os serviços oferecidos pelo MONKEY MONEY, os Usuários e
    Visitantes concordam com as condições previstas neste Termo. É recomendado
    aos Usuários que leiam tudo cuidadosamente para que, ao utilizar a
    Plataforma, possam compreender seus direitos e deveres.
  </p>
  <p>
    1.5. Este Termo integra conjuntamente a Política de Privacidade e Tratamento
    de Dados e ambos os documentos podem ser alterados a qualquer momento. As
    modificações entrarão em vigor 7 (sete) dias após sua divulgação. Em nenhum
    caso as alterações afetarão as operações já iniciadas e as finalizadas.
  </p>
  <p>
    1.6. Caso o Usuário possua algum tipo de discordância em relação a qualquer
    termo contido neste documento ou na Política de Privacidade e Tratamento de
    Dados, fica vedada a utilização do Marketplace e de qualquer outro produto
    e/ou serviços oferecidos ou fornecidos pelo MONKEY MONEY.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">2. O QUE É O MONKEY MONEY?</h3>
  <p>
    2.1. O objetivo da MONKEY MONEY é aproximar os fornecedores de seus
    consumidores. A Plataforma funciona como uma vitrine digital que contém
    informações de diversos produtos e serviços oferecidos pelas empresas locais
    e ofertados à população da região. Além da vitrine digital e da venda
    online, a empresa oferece ferramentas de CRM, Inteligência de Dados e
    treinamentos online, com o objetivo de potencializar os negócios dos
    empreendedores.
  </p>
  <p>
    2.2. O MONKEY MONEY não participa da cadeia produtiva dos produtos e/ou
    serviços oferecidos na Plataforma, tanto que sua remuneração advém das
    mensalidades pagas pelos VENDEDORES cadastrados; não há pagamento de
    comissões sobre as vendas efetuadas
  </p>
  <p>
    2.2.1. O MONKEY MONEY não detém conhecimento técnico acerca dos bens e
    serviços ofertados em sua plataforma, não tendo condições de descrever suas
    características e qualidades, sendo obrigação do COMPRADOR acercar-se dos
    cuidados necessários antes de realizar a compra. Por esse motivo, o MONKEY
    MONEY não faz declarações e, em aplicação a legislação brasileira, está
    desobrigado em relação: (1) a quaisquer produtos, serviços, informações,
    e/ou outros materiais oferecidos por terceiros e disponibilizados ao Usuário
    através da Plataforma; e (2) ao comportamento de qualquer terceiro com o
    qual o Usuário possa entrar em contato para utilização dos serviços
    oferecidos na Plataforma.
  </p>

  <p>
    2.3. O pagamento é feito diretamente pelo COMPRADOR para o VENDEDOR, sem
    qualquer controle por parte do MONKEY MONEY; a entrega dos produtos também é
    responsabilidade do VENDEDOR. A empresa Asaas Gestão Financeira Instituição
    de Pagamento S/A é uma parceira que disponibiliza o meio de pagamento e
    opera sem qualquer interferência do MONKEY MONEY, sendo que a remuneração da
    ASAAS é descontada do crédito que o VENDEDOR receberá do COMPRADOR.
  </p>
  <p>
    2.4. Por não estar envolvido na comercialização, o MONKEY MONEY é uma
    testemunha qualificada, na medida em que, se acionada por alguma das partes,
    poderá fazer contato com a outra em busca de esclarecimentos e, a partir dos
    registros das operações realizadas na plataforma, poderá ajudar a esclarecer
    os fatos controvertidos.
  </p>
  <p>
    2.5. O que o MONKEY MONEY faz é disponibilizar o acesso ao site/app que, por
    sua vez, é uma plataforma em que VENDEDORES e COMPRADORES são previamente
    cadastrados e identificados através de login e senha, de caráter pessoal e
    intransferível.
  </p>
  <p>
    2.6. O MONKEY MONEY coleta informações pessoais para prestar e continuamente
    melhorar seus produtos e serviços, por isso, coleta informações de todos os
    seus Usuários para identificar padrões de comportamento que auxiliem no
    desenvolvimento do negócios e faz tratamento de dados, conforme parâmetros
    definidos na Política de Privacidade do MONKEY MONEY
  </p>
  <p>
    2.7. O MONKEY MONEY assume a responsabilidade por: 2.7.1. Planejar,
    estruturar, controlar o acesso, moderar o conteúdo, orientar anúncios e
    garantir a segurança da Plataforma de Marketplace;
  </p>
  <p>
    2.7.2. Fornecer treinamentos de uso e de adoção de medidas de segurança na
    Plataforma;
  </p>
  <p>
    2.7.3. Disponibilizar meios de pagamento para efetivação das operações, que
    se dará por meio da empresa parceira Asaas Gestão Financeira Instituição de
    Pagamento S/A, conforme descrição no item 4.2;
  </p>
  <p>2.7.4. Rastrear as operações realizadas na Plataforma.</p>
  <p>
    2.8. O MONKEY MONEY possui a faculdade de interromper o acesso à Plataforma
    de Marketplace, pelo prazo de 48 (quarenta e oito) horas, para fins de
    manutenção preventiva e/ou corretiva.
  </p>
  <p>
    2.8.1. Sempre que possível, a interrupção será previamente avisada aos
    Usuários;
  </p>
  <p>
    2.8.2. O prazo previsto acima poderá ser prorrogado para 7 (sete) dias,
    quando ocorrer fato imprevisível decorrente de fato de terceiro, caso
    fortuito ou força maior, em especial, nas seguintes hipóteses: a) fatores
    climáticos excepcionais e imprevisíveis; b) greves parciais ou gerais; c)
    escassez de materiais por fato de terceiro; e d) atos de intervenção
    governamental.
  </p>
  <p>
    2.9. Por conta de questões técnicas e operacionais, o MONKEY MONEY não pode
    garantir a disponibilidade, a infalibilidade e a continuidade do
    funcionamento da Plataforma, Aplicativo e/ou Site.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">3. TARIFAS DE USO</h3>
  <p>
    3.1. O MONKEY MONEY obtém sua remuneração pela cobrança de tarifas mensais
    fixas dos Usuários que desejem comercializar seus produtos e/ou serviços
    dentro da Plataforma de Marketplace, denominados VENDEDORES.
  </p>
  <p>
    3.2. As tarifas serão tratadas em documento apartado negociado diretamente
    com o VENDEDOR.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">4. A PLATAFORMA DE MARKETPLACE</h3>
  <h3 style="color: black">4.1. O QUE É O MARKETPLACE?</h3>

  <p>
    4.1.1. O Marketplace é uma plataforma de comércio eletrônico disponibilizada
    pelo MONKEY MONEY que funciona como uma vitrine digital e contém as
    informações de diversos produtos e serviços oferecidos pelas empresas locais
    e ofertados à população da região. Além da vitrine digital e da venda
    online, a plataforma contempla ferramentas de CRM, Inteligência de dados e
    treinamentos online, fornecidos aos VENDEDORES.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">4.2. MEIOS DE PAGAMENTO</h3>

  <p>
    4.2.1. As modalidades de pagamentos disponíveis na Plataforma de Marketplace
    são regidas pela empresa Asaas Gestão Financeira Instituição de Pagamento
    S/A e suas políticas de pagamentos e uso podem ser consultadas através do
    link: Termos e Condições de Uso | Central de Ajuda Asaas | Confira nossos
    artigos e tire suas dúvidas.
  </p>
  <p>
    .2.2. Eventuais frustrações e/ou danos decorrentes de divergências nas
    informações prestadas pelo COMPRADOR no momento da compra não podem ser
    atribuídos à Plataforma, ao VENDEDOR ou à Gestora de Pagamentos - ASAAS.
  </p>
  <p>
    4.2.3. O MONKEY MONEY recomenda que para pagamentos nas modalidades crédito
    e/ou débito, seja utilizado cartão virtual gerado pela instituição
    financeira do CONSUMIDOR, em razão das vantagens de segurança oferecidas.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">4.2. MEIOS DE PAGAMENTO</h3>

  <p>
    4.3.1. Aqueles que desejam utilizar a Plataforma de Marketplace, seja como
    VENDEDOR ou COMPRADOR, deverão preencher um formulário de cadastro de conta
    com as informações e os dados que lhe forem requeridos.
  </p>

  <p>
    4.3.1.1. Ao preencher o formulário e se cadastrar como Usuário, a pessoa se
    compromete em fornecer as informações solicitadas de maneira verídica,
    exata, completa e inequívoca, possuindo a total ciência de que, caso assim
    não o faça, poderá estar prejudicando ou mesmo impossibilitando sua
    experiência de uso na Plataforma de Marketplace, inclusive aquelas
    relacionadas ao pagamento e recebimento de pagamento de compras realizadas
    na Plataforma.
  </p>

  <p>
    4.3.1.2. O MONKEY MONEY informa que nem todos os dados solicitados no
    formulário são de fornecimento obrigatório, mas seu preenchimento
    possibilita a oferta de uma melhor experiência de uso ao Usuário, com base
    em suas características pessoais.
  </p>
  <p>
    4.3.1.3. É obrigação de cada Usuário manter as informações cadastradas na
    plataforma atualizadas.
  </p>
  <p>
    4.3.1.4. Com a finalidade de adotar meios de prevenir e combater fraudes e
    golpes, garantindo assim a segurança e qualidade dos serviços prestados pela
    Plataforma, o MONKEY MONEY reserva-se o direito de solicitar cópias dos
    documentos que confirmem os dados fornecidos pelo Usuário para comprovação
    da veracidade.
  </p>
  <p>
    4.3.1.5. Em relação aos Usuários VENDEDORES, após o cadastro inicial na
    Plataforma, é necessário o envio de documentos de confirmação das
    informações prestadas, para validar a utilização da Plataforma pela empresa.
    Além disso, poderá ser exigida uma reunião presencial ou virtual para
    confirmação das informações e da geolocalização da empresa.
  </p>

  <p>
    4.3.2. Todo e qualquer contato realizado pelo MONKEY MONEY ao Usuário,
    independentemente do motivo; ocorrerá através dos meios oficiais de
    comunicação;
  </p>
  <p>
    4.3.2.1. O MONKEY MONEY, seus parceiros comerciais e seus licenciadores não
    irão entrar em contato com o Usuário com o intuito de solicitar a senha
    pessoal de acesso à Plataforma, ou os dados de cadastro - com exceção do
    item 4.3.1.4 e 4.3.1.5.
  </p>
  <p>
    4.3.2.2. Como medida de segurança, caso seja necessário contactar o Usuário,
    o MONKEY MONEY fornecerá um código de verificação que, em caso de dúvida,
    poderá ser confirmado por meio do
    <a style="color: rgb(255, 136, 0)">telefone: (31) 9975-3052</a>.
    Recomenda-se que o Usuário apenas preste informações pessoais e,
    principalmente, de pagamento, após a confirmação do código de validação.
  </p>

  <p>
    4.3.3. Na situação de inexatidão ou inveracidade dos dados fornecidos, o
    MONKEY MONEY reserva-se o direito de não aceitar o cadastro do Usuário,
    podendo o cadastro ser suspenso ou mesmo removido da Plataforma.
  </p>
  <p>
    4.3.4. O cadastro de conta no Marketplace é de responsabilidade de cada
    Usuário. A conta é pessoal, única e intransferível, ou seja, em nenhuma
    circunstância poderá ser vendida ou transferida para outra pessoa. A conta é
    acessada através de uma senha pessoal, criada no momento do cadastro e não
    deve ser repassada para terceiros em nenhuma hipótese, sendo o Usuário o
    único responsável pelo uso e gerenciamento de sua conta e senha.
  </p>
  <p>
    4.3.4.1. A senha de acesso à plataforma criada pelo Usuário, deve ser
    regularmente alterada e não deve ser de teor óbvio para terceiros.
  </p>
  <p>
    4.3.5. Ao deixar de utilizar a Plataforma, o Usuário deverá se desconectar
    ao final de cada sessão.
  </p>
  <p>
    4.3.6. Em uma eventual situação que o Usuário identifique o uso não
    autorizado de sua conta, deverá comunicar a ocorrência de tal acontecimento
    à equipe de suporte do MONKEY MONEY imediatamente, através do
    <a style="color: rgb(255, 136, 0)">telefone: (31) 9975-3052</a> e/ou

    <a style="color: rgb(255, 136, 0)">e-mail: atendimento@monkeymoney.com.br</a
    >.
  </p>
  <!-- *********************************************************************************** -->

  <h3 style="color: black">4.4. COMUNICAÇÕES E SERVIÇO DE ATENDIMENTO</h3>

  <p>
    4.4.1. Todas as comunicações entre os Usuários e o MONKEY MONEY, sejam elas
    relacionadas ao Serviço de Atendimento ao Consumidor (SAC) ou não, serão
    realizadas através de meios eletrônicos ou telefônicos oficiais da empresa
    MONKEY MONEY.
  </p>
  <p>
    4.4.2. Os Usuários possuem dos seguintes meios para entrar em contato com o
    MONKEY MONEY: 4.4.2.1. Telefone de contato:
    <a style="color: rgb(255, 136, 0)">(31) 9975-3052</a>; 4.4.2.2. E-Mail de
    contato:
    <a style="color: rgb(255, 136, 0)">atendimento@monkeymoney.com.br</a>;
    4.4.2.3. Através do centro de mensagens disponível na própria Plataforma de
    Marketplace.
  </p>

  <p>
    4.4.3. A funcionalidade do centro de mensagens disponibilizado dentro da
    Plataforma de Marketplace é regida pela empresa tawk.to e suas políticas de
    uso podem ser consultadas através do link: Privacy Policy – tawk.to.
  </p>

  <p>
    4.4.4. Caso o COMPRADOR necessite de entrar em contato para tratar de
    assuntos relacionados aos produtos e/ou serviços vendidos e entregues pelos
    VENDEDORES, deverá entrar em contato diretamente com o VENDEDOR através das
    informações de contato por ele disponibilizadas em seu perfil.
  </p>

  <p>
    4.4.5. Ao utilizar qualquer dos Serviços MONKEY MONEY, ou ao enviar e-mails,
    mensagens de texto (SMS), postar outras informações na Plataforma ou outros
    tipos de comunicação a partir de qualquer aparelho eletrônico, o Usuário
    estará se comunicando eletronicamente com a empresa, sendo assim, estará
    autorizando a lhe enviar comunicações eletrônicas por vários meios, tais
    como e-mail, mensagens de texto (SMS), outros serviços MONKEY MONEY, bem
    como pelo centro de mensagens. O Usuário concorda que quaisquer contratos,
    notificações, mensagens, divulgações e demais comunicações entregues
    eletronicamente satisfazem todas as exigências legais de que tal comunicação
    seja feita por escrito.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">4.5. POLÍTICA DE ENTREGA</h3>

  <p>
    4.5.1. A Política de entrega é de responsabilidade exclusiva do VENDEDOR,
    não deixe de consultá-lo. As informações pertinentes estarão ao final de
    cada operação realizada. O MONKEY MONEY não participa da logística de
    coleta, entrega ou devolução de produtos.
  </p>
  <p>
    4.5.2. O MONKEY MONEY ressalta ao VENDEDOR que ele deverá informar ao
    CONSUMIDOR o prazo de entrega do produto e/ou serviço, bem como qualquer
    alteração no prazo previsto, devendo, nesse caso, confirmar o interesse do
    comprador na manutenção da aquisição.
  </p>
  <p>
    4.5.3. A montagem ou desmontagem do produto, transporte pela escada e/ou
    portas e janelas, ou içamento das mercadorias, caso necessário, deverá ser
    acordado diretamente com o VENDEDOR.
  </p>
  <!-- *********************************************************************************** -->
  <h3 style="color: black">
    4.6. DIREITO DE ARREPENDIMENTO/POLÍTICA DE TROCAS
  </h3>

  <p>
    4.6.1. Dentro do prazo de até 07 (sete) dias após o recebimento de seu
    produto ou 07 (sete) dias após contratação/agendamento de um serviço junto a
    um VENDEDOR, fica facultado ao COMPRADOR exercer seu direito de
    arrependimento, que consiste na possibilidade de devolver o produto comprado
    ou não utilizar o serviço contratado e receber o estorno do valor pago no
    ato da compra.
  </p>

  <p>
    4.6.2. No mesmo prazo, pode o COMPRADOR, a seu critério, pleitear a troca de
    PRODUTOS adquiridos na Plataforma, por outro de fornecimento do mesmo
    VENDEDOR. Não é possível a troca de produtos entre VENDEDORES diversos.
  </p>
  <p>
    4.6.3. A devolução do produto deve ser acordada diretamente com o VENDEDOR,
    sendo a responsabilidade do VENDEDOR realizar o estorno e reembolso dos
    valores.
  </p>
  <p>
    4.6.4. Para os devidos fins, o prazo de 07 (sete) dias será contabilizado a
    partir do momento do agendamento do serviço a ser realizado pelo VENDEDOR
    junto ao COMPRADOR ou pela efetiva entrega do produto pelo operador
    logístico.
  </p>

  <p>
    4.6.5. Em caso do exercício do direito de arrependimento ou de troca, o
    produto deve ser devolvido na embalagem original na qual foi enviado ou em
    uma embalagem semelhante, deverá estar acompanhado de todos os seus
    acessórios e da nota fiscal.
  </p>
  <p>
    4.6.6. No momento em que o produto retornar ao VENDEDOR, ele deverá
    verificar se todas as exigências anteriores foram atendidas, bem como deverá
    conferir as condições do produto, se aparenta ter marcas relevantes de uso,
    dentre outras características que possam impedir ou diminuir a real
    funcionalidade do produto ora comprado.
  </p>
  <p>
    4.6.7. Caso o COMPRADOR aceite, nas situações em que o produto comprado não
    possa ser trocado por outro de características iguais ou similares, o
    COMPRADOR poderá receber vouchers, cupons ou outros meios correlatos como
    estorno no mesmo valor da compra realizada, a critério do VENDEDOR, e que
    poderão ser utilizados dentro da PLATAFORMA para aquisição de produtos do
    VENDEDOR que concedeu o voucher, cupom ou outro crédito correlato.
  </p>
  <p>
    4.6.7.1. Caso o COMPRADOR não aceite o reembolso através da maneira disposta
    no item acima, o reembolso será realizado através da devolução do valor da
    compra para uma conta bancária a ser indicada pelo usuário COMPRADOR ao
    VENDEDOR.
  </p>
  <p>
    4.6.7.2. O estorno será realizado de acordo com o valor pago, os descontos
    de vouchers ou cupons serão devolvidos de acordo com suas condições de uso.
  </p>
  <p>
    4.6.8. Caso o VENDEDOR não cumpra com as suas obrigações de devoluções,
    estornos e/ou reembolsos perante o COMPRADOR, poderá ter sua conta suspensa
    ou excluída do Marketplace, sem prejuízo da cobrança de eventuais perdas e
    danos, suportadas pelo MONKEY MONEY em decorrência deste descumprimento,
    devendo ainda ressarcir valores eventualmente pagos pelo MONKEY MONEY em
    decorrência de ações ou omissões do VENDEDOR, em desacordo com a legislação
    vigente.
  </p>
  <p>
    4.6.9. O VENDEDOR se compromete de forma absoluta com a política de
    desistência e de troca instituída nesta cláusula, tendo em vista que as
    vendas ocorridas na Plataforma são feitas na modalidade virtual.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">
    4.7. COMENTÁRIOS, OPINIÕES E AVALIAÇÃO DE PRODUTOS
  </h3>

  <p>
    4.7.1. Todos os Usuários que vierem a comprar na Plataforma poderão realizar
    comentários acerca dos produtos e/ou serviços adquiridos. Tal funcionalidade
    possui o intuito de que os Usuários possam efetuar a melhor compra possível
    tendo por base comentários opinativos e avaliações de outros Usuários, bem
    como a finalidade de que os VENDEDORES possam sempre melhorar a qualidade
    dos produtos e serviços vendidos no Marketplace.
  </p>

  <p>
    4.7.2. Ao publicar qualquer tipo de conteúdo no campo de comentários,
    avaliações ou ao enviar qualquer tipo de dúvidas, o Usuário se
    responsabiliza exclusivamente por tais conteúdos por ele criados, garantindo
    também ser o autor e proprietário exclusivo desses comentários.
  </p>
  <p>
    4.7.3. O MONKEY MONEY reserva-se o direito de exercer moderação sobre os
    comentários, opiniões e avaliações postados na Plataforma, podendo deletar
    comentários e/ou bloquear Usuários que infrinjam as normas e disseminem:
  </p>
  <p>
    4.7.3.1. Material discriminatório, de caráter ofensivo, ilegal,
    preconceituoso e/ou racista;
  </p>
  <p>
    4.7.3.2. Ameaças, perjúrio, difamação ou qualquer conteúdo inapropriado que
    viole os padrões da Plataforma ou da legislação brasileira;
  </p>
  <p>4.7.3.3. Textos, fotos, vídeos de teor violento, rude e/ou grosseiro;</p>
  <p>
    4.7.3.4. Promoções, fan pages, materiais de campanhas eleitorais de qualquer
    partido e propagandas de terceiros;
  </p>
  <p>4.7.3.5. Informações que promovam mentiras ou conteúdo inverídico;</p>
  <p>
    4.7.3.6. Informações pessoais, endereços, e-mails, informações de terceiros,
    ou que faça referência a outras empresas e sites;
  </p>
  <p>
    4.7.3.7. Informações que contenham algum tipo de vírus, "spam" (lixo
    eletrônico), dentre outros assuntos correlatos.
  </p>
  <!-- *********************************************************************************** -->

  <h3 style="color: black">4.8. LINKS DE TERCEIROS</h3>

  <p>
    4.8.1. A Plataforma de Marketplace pode conter links para sites de terceiros
    que não são de propriedade ou controlados pelo MONKEY MONEY. As referências
    na Plataforma a quaisquer nomes, marcas, produtos ou serviços de terceiros,
    ou links para seus respectivos sites ou informações não são um endosso,
    patrocínio ou recomendação do terceiro ou de suas informações, produtos ou
    serviços.
  </p>
  <p>
    4.8.1.1. O Usuário pode criar um link para a Plataforma de Marketplace a
    partir de seu próprio site, desde que não implique nenhum endosso ou
    associação com o MONKEY MONEY.
  </p>
  <p>
    4.8.2. O MONKEY MONEY não possui controle, não endossa ou verifica o
    conteúdo, políticas de privacidade, ou práticas de sites ou serviços de
    terceiros, incluindo, mas não se limitando, a qualquer mídia social ou
    plataformas de aplicativos móveis de terceiros com os quais o site interage.
    O uso de qualquer site ou plataforma de terceiros é realizado por conta e
    risco do Usuário e será regido pelos Termos de Uso e Políticas de tais
    terceiros (incluindo suas Políticas de Privacidade).
  </p>
  <p>
    4.8.3. Qualquer conteúdo carregado na Plataforma por um usuário que não seja
    da equipe do MONKEY MONEY, é fornecido em sua forma original, e sem
    quaisquer garantias ou representações de qualquer tipo. O MONKEY MONEY
    aconselha que o Usuário leia todos os Termos e Condições de Uso e Políticas
    de Privacidade destes Terceiros.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">5. OBRIGAÇÕES DO USUÁRIO VENDEDOR</h3>

  <p>
    5.1. Considera-se como "VENDEDOR" para os fins deste Termo todo Usuário
    pessoa jurídica que disponibilize produtos e serviços na Plataforma de
    Marketplace para venda, agendamento ou visualização.
  </p>

  <p>
    5.1.1. Aquele que fizer uso da plataforma em representação de uma empresa
    deverá ter capacidade para contratar em nome dela.
  </p>

  <p>
    5.1.2. Não é autorizada a comercialização de produtos ou serviços por
    pessoas físicas na Plataforma de Marketplace.
  </p>

  <p>
    5.1.3. Para utilizar a plataforma como VENDEDOR, ao Usuário será cobrado uma
    tarifa mensal acordada no momento de assinatura da Plataforma e tratada no
    CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE MARKETPLACE.
  </p>
  <p>
    5.1.4. Para permanecer como VENDEDOR na Plataforma o Usuário deverá cumprir
    com suas obrigações financeiras de pagamento da tarifa estipulada, correndo
    o risco de, se não for efetuado o pagamento, ter seu acesso à Plataforma e
    conta indisponibilizados ou mesmo excluídos.
  </p>
  <p>
    5.2. O VENDEDOR se compromete a seguir a Política de Privacidade, este
    Termos e Condições Gerais de Uso, o CONTRATO DE PRESTAÇÃO DE SERVIÇOS DE
    MARKETPLACE, inclusive eventuais alterações posteriores, assim como toda e
    qualquer legislação vigente que se relacione a venda e comercialização de
    serviços e produtos, além de resguardar quaisquer informações e/ou materiais
    concedidos e ou postados na Plataforma seguindo as diretrizes da legislação
    vigente.
  </p>
  <p>
    5.3. O VENDEDOR se responsabiliza pela contratação do transporte ou pela
    logística de entrega de mercadorias compradas através da Plataforma, sendo
    também de sua responsabilidade a embalagem, o transporte, o frete e a
    garantia de entrega ao consumidor final dos produtos comercializados através
    da Plataforma.
  </p>
  <p>
    5.4. Os VENDEDORES usam o MONKEY MONEY para publicar e definir as condições
    de sua oferta. Por isso, serão responsáveis pela existência, qualidade,
    quantidade, regularidade, garantia, integridade e/ou legitimidade dos
    produtos que oferecem, e manterão indene o MONKEY MONEY por qualquer ação
    administrativa ou judicial que possa ser gerada por uma oferta ou venda.
  </p>
  <p>
    5.5. Para utilização da Plataforma serão solicitadas ao VENDEDOR informações
    para acesso a serviços externos, como: nome da conta; e-mail; CNPJ; nome
    completo do responsável pela empresa e CPF; conta bancária; tipo de empresa;
    número de contato; endereço; número do endereço; complemento e bairro.
  </p>
  <p>
    5.5.1. Após o cadastro inicial serão solicitados registros e documentos que
    sejam considerados pertinentes e necessários para verificação das
    informações fornecidas e que sejam de relevância para acesso a serviços
    externos (como serviço de pagamento, serviços logísticos e afins). A título
    de exemplo, será exigido o contrato social da empresa e alterações,
    comprovação de registro no Cadastro Nacional de Pessoas Jurídicas, documento
    pessoal do sócio administrador e comprovante de endereço do sócio
    administrador.
  </p>
  <p>
    5.5.2. Poderá também ser exigida uma reunião presencial ou virtual para
    confirmação das informações e da geolocalização da empresa.
  </p>
  <p>
    5.6. O VENDEDOR concorda em prestar ao MONKEY MONEY todas as informações que
    venham a ser solicitadas para verificações periódicas, assim como deverá
    fornecer todas as documentações que o MONKEY MONEY entender pertinentes
    relacionadas à venda de produtos na Plataforma. O VENDEDOR confirma que
    todos os seus documentos, informações e materiais são genuínos, precisos,
    completos e não enganosos.
  </p>
  <p>
    5.7. Com o objetivo de dar cumprimento às finalidades listadas neste Termo,
    as informações e materiais fornecidos ou compartilhados seguirão a Política
    de Privacidade e Tratamento de Dados, bem como a dos parceiros comerciais e
    licenciadores, a partir do momento em que forem compartilhadas com eles.
  </p>
  <p>
    5.8. Em relação a cada Comprador, o VENDEDOR é obrigado a (a) respeitar as
    condições de venda publicadas na PLATAFORMA; (b) emitir a Nota Fiscal ou
    outro documento equivalente, em conformidade com a legislação fiscal
    aplicável; (c) garantir o direito de cancelar ou revogar a compra dentro do
    prazo legal; (d) respeitar as garantias legais aplicáveis, conforme o caso;
    e (e) pagar os custos de cancelamentos, estornos ou devolução dos produtos,
    conforme previsão no item 4.6.
  </p>
  <p>
    5.9. O VENDEDOR concorda em usar apenas os meios de pagamento
    disponibilizados pela gestora de pagamentos, Asaas Gestão Financeira
    Instituição de Pagamento S/A, a fim de garantir a segurança das operações e
    o funcionamento dos programas de proteção.
  </p>
  <p>
    5.10. O VENDEDOR é obrigado a sanar eventuais dúvidas, solicitações,
    entregas, reclamações ou qualquer outro tipo de demanda levantada pelo
    COMPRADOR.
  </p>
  <p>
    5.10.1. O MONKEY MONEY atuará como uma testemunha qualificada, na medida em
    que, se acionada por alguma das partes, poderá fazer contato com a outra em
    busca de esclarecimentos e, a partir dos registros das operações realizadas
    na plataforma, poderá ajudar a esclarecer os fatos controvertidos.
  </p>
  <p>
    5.10.2. Caso o VENDEDOR não cumpra com as suas obrigações perante o
    COMPRADOR, poderá ter sua conta suspensa ou excluída do Marketplace, sem
    prejuízo da cobrança de eventuais perdas e danos, suportadas pelo MONKEY
    MONEY em decorrência deste descumprimento, devendo ainda ressarcir valores
    eventualmente pagos pelo MONKEY MONEY em decorrência de ações ou omissões do
    VENDEDOR, em desacordo com a legislação vigente.
  </p>
  <p>
    5.11. Todos os VENDEDORES são responsáveis, inclusive judicialmente, pelo
    direito de imagem e uso de imagens utilizadas para poderem promover a venda
    de seus produtos e/ou serviços na Plataforma, albergando não apenas aquelas
    relacionadas a itens, produtos e coisas em si, mas também as imagens de
    pessoas, sejam elas maiores ou menores de idade, não podendo o MONKEY MONEY
    ser responsabilizado de nenhuma forma, inclusive legal, pela má utilização
    ou utilização sem permissão de tais imagens por parte dos VENDEDORES, em
    desconformidade com as leis vigentes e disposições contidas neste Termo.
  </p>
  <p>
    5.12. O MONKEY MONEY se reserva o direito de remover imagens da Plataforma
    caso algum VENDEDOR venha a utilizá-la de modo a violar leis, direitos, a
    intimidade, a vida privada, a honra e a imagem de terceiros e não assume a
    responsabilidade por qualquer tipo de prejuízo que o VENDEDOR possa ter
    advindo dessa remoção.
  </p>
  <p>
    5.13. O MONKEY MONEY poderá, a seu critério, priorizar anúncios em virtude
    da geolocalização dos Usuários Compradores, bem como de outros fatores que
    considere relevantes, com o objetivo de melhorar a experiência de compra
    deles.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">6. OBRIGAÇÕES DO USUÁRIO COMPRADOR</h3>

  <p>
    6.1. Considera-se como "COMPRADOR" todo e qualquer Usuário que venha a
    realizar compras e agendamentos na Plataforma de Marketplace, ou que
    simplesmente possua uma conta na Plataforma.
  </p>

  <p>
    6.2. Poderão utilizar os serviços oferecidos pela Plataforma de Marketplace,
    na qualidade de COMPRADORES as pessoas maiores de dezoito anos com
    capacidade legal para contratar e que estejam de pleno acordo com este Termo
    e com a Política de Privacidade e Tratamento de Dados.
  </p>

  <p>
    6.2.1. O MONKEY MONEY reserva a si o direito de excluir o cadastro e
    cancelar os pedidos de pessoas menores de dezoito anos, bem como de pessoas
    maiores, mas que porventura não estejam em gozo de sua plena capacidade,
    seja por qual motivo for.
  </p>

  <p>
    6.2.2. Neste momento, não é possível a aquisição de produtos ou serviços por
    pessoas jurídicas.
  </p>

  <p>
    6.3. Com exceção do disposto neste Termo, na Política de Privacidade e
    Tratamento de Dados ou em um acordo colateral, tudo que o Usuário enviar ou
    publicar na Plataforma, incluindo, sem limitação, fotos, vídeos, know-how e
    técnicas, será tratado como não confidencial.
  </p>

  <p>
    6.4. Pessoas menores de 18 anos, além de não poderem utilizar a plataforma –
    como descrito no item 6.2 –, estão proibidas de postar imagens de si mesmas
    e todo Usuário da plataforma está proibido de postar imagens de pessoas com
    menos de 18 (dezoito) anos na Plataforma.
  </p>

  <p>
    6.4.1. Em casos de avaliações de produtos é recomendado que sejam enviadas
    imagens apenas dos produtos e que não seja evidenciada em nenhum momento
    rostos de pessoas menores de 18 (dezoito) anos.
  </p>

  <p>
    6.5. O Comprador poderá encontrar no anúncio todas as informações que o
    VENDEDOR fornecer em relação ao produto oferecido. O MONKEY MONEY recomenda
    ao COMPRADOR a leitura atenta de etiquetas, advertências, instruções e
    certificados de garantia antes de utilizar ou consumir o produto.
  </p>

  <p>
    6.6. Em casos de devolução de produtos eletrônicos, por qualquer razão, o
    MONKEY MONEY recomenda que o COMPRADOR proceda com a exclusão de qualquer
    dado pessoal que possa ter inserido no dispositivo.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">7. PRIVACIDADE DE DADOS</h3>

  <p>
    7.1. O MONKEY MONEY faz o uso dos dados fornecidos de maneira responsável e
    de acordo com a legislação pertinente, com a observância das medidas
    necessárias para garantir a segurança dos dados de todos os Usuários da
    Plataforma.
  </p>

  <p>
    7.2. O MONKEY MONEY possui uma Política de Privacidade e Tratamento de Dados
    de leitura obrigatória a todos os Usuários, disponível no link:
    https://bit.ly/politicaprivacidademonkeymoney.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">8. ACESSO A OUTRAS INFORMAÇÕES COMERCIAIS</h3>

  <p>
    8.1. Além do disposto nas seções anteriores, o MONKEY MONEY oferece
    ferramentas, aplicações e serviços com base em outras informações comerciais
    fornecidas pelos Usuários e/ou geradas ao usar os serviços da Plataforma,
    para ajudar os VENDEDORES a otimizarem suas vendas, elevar os volumes e
    gerenciar seus negócios. Além disso, é possível usá-las para oferecer aos
    Usuários promoções, produtos e serviços de outras empresas ou de marcas
    compartilhadas, também podem ser utilizadas em programas de prevenção à
    fraude e outras medidas visando aumentar a segurança do Marketplace, dos
    Usuários e o cumprimento dos Termos e Condições Gerais de Uso. Saiba mais
    sobre a Política de Privacidade.
  </p>

  <p>
    8.2. Em qualquer caso, os VENDEDORES que utilizem esses produtos e serviços
    não poderão utilizar a Propriedade Intelectual do MONKEY MONEY de uma forma
    que cause confusão no público, e deverão realizar sua atividade comercial
    sob uma marca ou nome comercial próprio e distintivo, que não seja
    confundível com a marca MONKEY MONEY.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">9. LICENÇA LIMITADA</h3>

  <p>
    9.1. O MONKEY MONEY concede aos Usuários uma licença limitada, revogável e
    não exclusiva para acessar e utilizar a Plataforma e os Serviços, sujeitos a
    este Termo de Uso e Condições. A licença concedida nesta cláusula será
    imediatamente revogada no caso de qualquer violação do presente Termo.
  </p>

  <p>
    9.2. Ao usar ou acessar a Plataforma, o Usuário concorda que todo e qualquer
    conteúdo, marcas registradas, marcas de serviço, nomes de marcas, logotipos,
    software e suas funcionalidades e outras propriedades intelectuais exibidas
    na Plataforma estão sujeitos às disposições contidas neste Termo e são de
    propriedade do MONKEY MONEY, de seus parceiros comerciais e seus
    licenciadores, e, no que aplicável, de terceiros identificados na
    Plataforma.
  </p>
  <p>
    9.2.1. Esses itens são protegidos pela legislação relacionada ao direito de
    propriedade intelectual, autorais e correlatos e somente serão passíveis de
    utilização pelos Usuários nos limites contidos neste Termo e conforme for
    acordado entre o MONKEY MONEY e o Usuário.
  </p>

  <p>
    9.2.2. Nenhum direito ou licença é concedido direta ou indiretamente a
    qualquer parte que acesse a plataforma para usar ou reproduzir qualquer
    Propriedade Intelectual.
  </p>
  <p>
    9.3. O Usuário não deverá carregar, distribuir ou publicar de outra forma,
    através da plataforma, qualquer conteúdo, informação ou outro material que:
  </p>
  <p>
    9.3.1. Viole ou infrinja os direitos autorais, patentes, marcas registradas,
    marcas de serviço, segredos comerciais ou outros direitos intelectuais e
    correlatos de qualquer pessoa, sem ter a permissão para ser carregado,
    distribuído através do site ou de outra forma publicado através do site pelo
    Usuário;
  </p>
  <p>
    9.3.2. Seja discriminatório, de caráter ofensivo, ilegal, preconceituoso
    e/ou racista ou que viole os padrões da Plataforma;
  </p>
  <p>
    9.3.3. Contenha propaganda, fan pages, materiais de conteúdo eleitoral e
    propagandas de terceiros;
  </p>
  <p>
    9.3.4. Contenha informações que promovam mentiras ou conteúdo inverídico;
  </p>
  <p>
    9.3.5. Contenha informações pessoais, endereços, e-mails, informações de
    terceiros, ou que faça referência a outras empresas e sites; e,
  </p>
  <p>
    9.3.6. Inclua qualquer código, materiais ou qualidades maliciosas ou
    tecnologicamente prejudiciais, tais como bugs, vírus, armadilhas, cavalos de
    Tróia, etc.
  </p>
  <p>
    9.3.7. Espelhe ou enquadre qualquer parte, ou a íntegra do conteúdo do site
    em qualquer outro servidor, ou como parte de qualquer outro site.
  </p>
  <p>
    9.4. Ao aceitar este Termo o Usuário concorda que, se alguma infração for
    detectada, e sem prejuízo das sanções previstas nesse Termo, o MONKEY MONEY
    poderá, a seu exclusivo critério, suspender ou remover anúncios totalmente
    ou parcialmente e/ou encerrar o acesso do Usuário à Plataforma a qualquer
    momento, sem que isso gere direito a uma indenização.
  </p>
  <p>
    9.5. O Usuário reconhece que o MONKEY MONEY pode, a seu exclusivo critério e
    a qualquer momento, encerrar o fornecimento de seus Serviços, seja em parte
    ou como um todo.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">10. RECLAMAÇÕES</h3>

  <p>
    10.1. Caso algum Usuário acredite que algum item divulgado por algum
    VENDEDOR possa estar violando seus direitos autorais, de propriedade
    intelectual ou correlatos, deverá contactar o MONKEY MONEY através do e-mail
    (atendimento@monkeymoney.com.br), informando o assunto “Reclamação de
    Direitos Autorais”, e apresentar documentação pertinente que comprove sua
    reivindicação, propriedade e direito sobre aquilo que esteja reivindicando.
  </p>
  <p>
    10.2. É de inteira responsabilidade dos Usuários que utilizam do
    Marketplace, em especial dos VENDEDORES, toda e qualquer atribuição legal
    que envolva reivindicações, demandas e condenações relacionadas a
    reclamações de direitos autorais, de propriedade intelectual ou correlatos,
    bem como, qualquer dano ou perda, inclusive perda de vendas ou possíveis
    vendas, causadas ao VENDEDOR advindo da remoção de qualquer conteúdo,
    produto e/ou serviço da plataforma por causa dessas reivindicações, demandas
    e reclamações de tais direitos por aqueles que são os reais detentores e
    proprietários.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">11. VIOLAÇÕES E SANÇÕES</h3>

  <p>
    11.1. Violações a este Termo ou à legislação por parte do Usuário poderá
    ensejar a aplicação de ações sancionatórias, cumulativamente ou não, tais
    quais: imposição de limitações de uso na conta do Usuário; exclusão ou
    suspensão da conta; exclusão de anúncios de produtos e/ou serviços vendidos;
    suspensão de funcionalidades da Plataforma para o Usuário; acusações
    criminais; ações cíveis; dentre outras medidas cabíveis.
  </p>
  <p>
    11.2. Eventuais violações ao presente Termo ou qualquer legislação
    pertinente a ele, poderá ser informada através dos seguintes canais de
    comunicação:
  </p>
  <p>
    11.2.1. Telefone: <a style="color: rgb(255, 136, 0)">(31) 9975-3052</a>;
  </p>
  <p>
    11.2.2. E-Mail de contato:
    <a style="color: rgb(255, 136, 0)">atendimento@monkeymoney.com.br</a>.
  </p>
  <p>
    11.3. O Usuário penalizado poderá apresentar um pedido de reconsideração, a
    ser enviado para o e-mail de contato: atendimento@monkeymoney.com.br. No
    pedido deve ser demonstrada a inexistência de violação e, caso necessário,
    apresentadas as provas necessárias para comprovação das alegações.
  </p>

  <!-- *********************************************************************************** -->

  <h3 style="color: black">12. FORO</h3>

  <p>
    12.1. Nos casos em que o local de eleição do foro for admitido, quaisquer
    controvérsias inerentes a este Termo serão tratadas e resolvidas no foro da
    comarca de Ipatinga/MG, com a exclusão de qualquer outro, por mais
    privilegiado que seja.
  </p>
</body>
